import configuration from "@intlayer/config/built";
import { fetcher } from "../fetcher.mjs";
const getUserAPI = (authAPIOptions = {}, intlayerConfig) => {
  const backendURL = intlayerConfig?.editor?.backendURL ?? configuration.editor?.backendURL;
  if (!backendURL) {
    throw new Error(
      "Backend URL is not defined in the Intlayer configuration."
    );
  }
  const USER_API_ROUTE = `${backendURL}/api/user`;
  const getUsers = async (filters, otherOptions = {}) => await fetcher(
    USER_API_ROUTE,
    authAPIOptions,
    otherOptions,
    {
      params: filters
    }
  );
  const getUserById = async (userId, otherOptions = {}) => await fetcher(
    `${USER_API_ROUTE}/${userId}`,
    authAPIOptions,
    otherOptions
  );
  const getUserByEmail = async (email, otherOptions = {}) => await fetcher(
    `${USER_API_ROUTE}/email/${email}`,
    authAPIOptions,
    otherOptions
  );
  const getUserByAccount = async (providerAccountId, provider, otherOptions = {}) => await fetcher(
    `${USER_API_ROUTE}/account/${provider}/${providerAccountId}`,
    authAPIOptions,
    otherOptions
  );
  const createUser = async (user, otherOptions = {}) => await fetcher(
    `${USER_API_ROUTE}/`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body: user
    }
  );
  const updateUser = async (user, otherOptions = {}) => await fetcher(
    `${USER_API_ROUTE}`,
    authAPIOptions,
    otherOptions,
    {
      method: "PUT",
      body: user
    }
  );
  const deleteUser = async (userId, otherOptions = {}) => await fetcher(
    `${USER_API_ROUTE}/${userId}`,
    authAPIOptions,
    otherOptions,
    {
      method: "DELETE"
    }
  );
  const getVerifyEmailStatusURL = (userId) => `${USER_API_ROUTE}/verify-email-status/${String(userId)}`;
  return {
    createUser,
    getUsers,
    getUserById,
    getUserByAccount,
    getUserByEmail,
    updateUser,
    deleteUser,
    getVerifyEmailStatusURL
  };
};
export {
  getUserAPI
};
//# sourceMappingURL=user.mjs.map